import Configurator from 'bookingbug-configurator-js';
import axios from 'axios';

const http = axios.create({
  headers: {
    'App-Id': 'f6b16c23',
    'App-Key': 'f0bc4f65f4fbfe7b4b3b7264b655f5eb',
  },
});

const api = {
  getCompany() {
    const apiUrl = Configurator.getConfig('apiUrl');
    const apiVersion = Configurator.getConfig('apiVersion') || 'v5';
    const companyId = Configurator.getConfig('companyId') || 37000;
    return http.get(`${apiUrl}/api/${apiVersion}/company/${companyId}`);
  },
  checkin(code) {
    const apiUrl = Configurator.getConfig('apiUrl');
    const apiVersion = Configurator.getConfig('apiVersion') || 'v5';
    const companyId = Configurator.getConfig('companyId') || 37000;
    const url = `${apiUrl}/api/${apiVersion}/${companyId}/check_in/${code}`;
    const config = { params: { legacy_mode: true } };
    return http.put(url, null, config);
  },

  getService(data) {
    // eslint-disable-next-line
    return http.get(data._links.service.href);
  },
};

export default api;
